import React from "react";

const OptionalDonation = ({
  handleOptionalSelectUpdate,
  selectedTier,
  chuffedAmountDisabled,
  currencySymbol,
  donationSelectedAmount,
  calculateOptionalAmount,
}) => (
  <div>
    <span className="fees__donation-form-fee">
      <p>Tipping Chuffed.org (optional):</p>
      <select
        className="optional-selector__select"
        id="donation-form-optional-tier"
        onChange={handleOptionalSelectUpdate}
        value={selectedTier}
        disabled={chuffedAmountDisabled}
      >
        {
            calculateOptionalAmount(donationSelectedAmount, 0) !== null
                    && (
                    <option value={0}>
                      {currencySymbol}
                      { calculateOptionalAmount(donationSelectedAmount, 0) }
                    </option>
                    )
          }
        <option value={1}>
          {currencySymbol}
          { calculateOptionalAmount(donationSelectedAmount, 1) }
        </option>
        <option value={2}>
          {currencySymbol}
          { calculateOptionalAmount(donationSelectedAmount, 2) }
        </option>
        <option value={3}>
          {currencySymbol}
          { calculateOptionalAmount(donationSelectedAmount, 3) }
        </option>
        <option value={4}>
          {currencySymbol}
          { calculateOptionalAmount(donationSelectedAmount, 4) }
        </option>
      </select>
    </span>
  </div>
);

export default OptionalDonation;
